import { computed, type Ref } from 'vue'
import { Table } from '@dacr/ui'
import { TableTypes } from '@/shared/types'
import type { File, Item } from '@/shared/graphql/router/graphql'
import { isFile, isFolder } from '@/features/explorer/utils/itemGuards'

export function useExplorerSelection(items: Ref<Item[] | undefined>) {
  const table = Table.useTable(TableTypes.Explorer)

  const selectedItems = computed(() =>
    (items.value || []).filter((item) => table.isRowSelected(item.id))
  )

  const selectedFiles = computed(
    () =>
      selectedItems.value.filter(isFile) as (File & { __typename: 'File' })[]
  )

  const areAllSelectedRowsFiles = computed(
    () => selectedItems.value.length > 0 && selectedItems.value.every(isFile)
  )

  const areAllSelectedRowsFolders = computed(
    () => selectedItems.value.length > 0 && selectedItems.value.every(isFolder)
  )

  const selectedRowsAreAllFiles = computed(() =>
    selectedItems.value.every(isFile)
  )

  const selectedRowsAreAllFolders = computed(() =>
    selectedItems.value.every(isFolder)
  )

  return {
    table,
    selectedItems,
    selectedFiles,
    areAllSelectedRowsFiles,
    areAllSelectedRowsFolders,
    selectedRowsAreAllFiles,
    selectedRowsAreAllFolders,
  }
}
